/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    framedContainerBackgroundColor: '#fafafa',
    framedContainerBorderColor: '#e3e6e8',
    framedContainerBorderRadius: 4,
    framedContainerBorderWidth: 1,
    framedContainerPadding: 24,
    framedMaxHeight: 640,
    stackViewDividerColor: '#e3e6e8'
  }
}
export default theme
